import { RadioButton, RadioGroup } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { pitchOrientationAtom } from '@/atoms/visualisation';
import { PITCH_ORIENTATION } from '@/consts/visualisations';
import { useSetQueryParams } from '@/hooks/queryParams/useSetQueryParams';
import { ConfigDisplaySettingKey } from '@/types/userConfigs';
import { snakeToCamel } from '@/utils/queries';

export const PitchOrientationToggle = () => {
  const { t } = useTranslation('visualisation');
  const pitchOrientation = useAtomValue(pitchOrientationAtom);

  const setQueryParams = useSetQueryParams();

  return (
    <RadioGroup groupId="pitch-crop-group" groupTitle={t('orientation.pitchOrientation')} size="regular">
      {PITCH_ORIENTATION.map(orientation => (
        <RadioButton
          key={orientation}
          checked={orientation === pitchOrientation}
          onChange={() => setQueryParams(ConfigDisplaySettingKey.PITCH_ORIENTATION, orientation)}
          id={`option-${orientation}`}
          label={t(`orientation.${snakeToCamel(orientation.toLocaleLowerCase())}`)}
          value={orientation}
          size="small"
        />
      ))}
    </RadioGroup>
  );
};
